module.exports = __webpack_public_path__ + "img/briller_logo.ca14c192.png";